import { apiRequest } from './api'
import type { Document, ListDocumentsParams, ListDocumentsResponse } from '@/types'

// List documents with filtering and pagination
export async function listDocuments(
  params: ListDocumentsParams
): Promise<ListDocumentsResponse> {
  const queryParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.set(key, String(value))
    }
  })

  return apiRequest<ListDocumentsResponse>(`/documents/list?${queryParams}`)
}

// Get single document by ID
export async function getDocument(id: string): Promise<Document> {
  return apiRequest<Document>(`/documents/get/${encodeURIComponent(id)}`)
}

// Update document
export async function updateDocument(
  id: string,
  data: Partial<Document>
): Promise<Document> {
  return apiRequest<Document>(`/documents/update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

// Get related documents
export async function getRelatedDocuments(
  id: string
): Promise<{ documents: Document[] }> {
  return apiRequest<{ documents: Document[] }>(
    `/documents/related/${encodeURIComponent(id)}`
  )
}

// Get presigned URL for document download
export async function getPresignedUrl(s3Key: string): Promise<string> {
  const response = await apiRequest<{ url: string }>(
    `/documents/download?s3_key=${encodeURIComponent(s3Key)}`
  )
  return response.url
}

// Delete document (soft delete - keeps file in S3)
export async function deleteDocument(id: string): Promise<{ message: string }> {
  return apiRequest<{ message: string }>(`/documents/delete/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  })
}

// Approve document (transition from manual_review to validated)
export async function approveDocument(id: string): Promise<Document> {
  return apiRequest<Document>(`/documents/approve/${encodeURIComponent(id)}`, {
    method: 'POST',
  })
}
